import React, { useState, useEffect } from 'react';
import './admingallery.css';
import { db, storage } from '../../config/firebase'; // Ensure the import path
import { collection, addDoc, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { BiTrash} from 'react-icons/bi';

const AdminGallery = () => {
    const [title, setTitle] = useState('');
    const [image, setImage] = useState(null);
    const [galleryImages, setGalleryImages] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [posts, setPosts] = useState([]);
    const [postTitle, setPostTitle] = useState('');
    const [postImage, setPostImage] = useState(null);
    const [author, setAuthor] = useState('');
    const [message, setMessage] = useState('');

    // Define fetchImages function
    const fetchImages = async () => {
        const querySnapshot = await getDocs(collection(db, 'gallery'));
        const imagesList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setGalleryImages(imagesList);
    };

    // Define fetchPosts function
    const fetchPosts = async () => {
        const querySnapshot = await getDocs(collection(db, 'posts'));
        const postsList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setPosts(postsList);
    };

    useEffect(() => {
        fetchImages();
        fetchPosts();
    }, []);


    const handleImageUpload = async (e) => {
        e.preventDefault();
        if (!image) return;
        setIsUploading(true);

        const storageRef = ref(storage, `gallery/${image.name}`);
        const uploadTask = uploadBytesResumable(storageRef, image);

        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${progress}% done`);
            },
            (error) => {
                console.error('Upload failed:', error);
                alert('There was an error uploading the image. Please try again.');
                setIsUploading(false);
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
                    try {
                        await addDoc(collection(db, 'gallery'), {
                            title,
                            imageUrl: downloadURL,
                            uploadedAt: new Date()
                        });
                        alert('Image uploaded successfully!');
                        setTitle('');
                        setImage(null);
                        fetchImages(); // Call fetchImages to update the gallery after upload
                    } catch (error) {
                        console.error('Error adding document: ', error);
                        alert('There was an error uploading the image. Please try again.');
                    } finally {
                        setIsUploading(false);
                    }
                });
            }
        );
    };

    const handleDeleteImage = async (id) => {
        try {
            await deleteDoc(doc(db, 'gallery', id));
            setGalleryImages(prevImages => prevImages.filter(image => image.id !== id));
        } catch (error) {
            console.error('Error deleting document: ', error);
            alert('There was an error deleting the image. Please try again.');
        }
    };

    const handlePostUpload = async (e) => {
        e.preventDefault();
        if (!postImage) return;
        setIsUploading(true);

        const storageRef = ref(storage, `posts/${postImage.name}`);
        const uploadTask = uploadBytesResumable(storageRef, postImage);

        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${progress}% done`);
            },
            (error) => {
                console.error('Upload failed:', error);
                alert('There was an error uploading the image. Please try again.');
                setIsUploading(false);
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
                    try {
                        await addDoc(collection(db, 'posts'), {
                            title: postTitle,
                            imageUrl: downloadURL,
                            author,
                            message,
                            uploadedAt: new Date()
                        });
                        alert('Post uploaded successfully!');
                        setPostTitle('');
                        setPostImage(null);
                        setAuthor('');
                        setMessage('');
                        fetchPosts(); // Call fetchPosts to update the posts after upload
                    } catch (error) {
                        console.error('Error adding document: ', error);
                        alert('There was an error uploading the post. Please try again.');
                    } finally {
                        setIsUploading(false);
                    }
                });
            }
        );
    };

    const handleDeletePost = async (id) => {
        try {
            await deleteDoc(doc(db, 'posts', id));
            setPosts(prevPosts => prevPosts.filter(post => post.id !== id));
        } catch (error) {
            console.error('Error deleting document: ', error);
            alert('There was an error deleting the post. Please try again.');
        }
    };

    return (
        <div className={`admin_gallery_container ${isUploading ? 'uploading' : ''}`}>
            {isUploading && (
            <div className='uploading_overlay'>
                <div className='uploading_message'>Uploading...</div>
            </div>
            )}

            <div className="media_heading">
                <h1>Welcome to your media page</h1>
                <p>"Upload images, delete, post news and manage everything in just a click"</p>
            </div>
            <div className="media_section">
                <div className="media_upload">
                    <h1>Upload image to the EWCDC Gallery</h1>
                    <input type="file" onChange={(e) => setImage(e.target.files[0])} />
                    <button className='media_btn' onClick={handleImageUpload} disabled={isUploading}>Upload</button>
                    {isUploading && <p className='uploading_indicator'>Uploading...</p>}
                </div>
                <div className="media_grid">
                    {galleryImages.length > 0 ? (
                        galleryImages.map((image) => (
                            <div className="grid_gallery" key={image.id}>
                                <img src={image.imageUrl} alt={image.title} />
                                <BiTrash className='image_btn' onClick={() => handleDeleteImage(image.id)} />
                            </div>
                        ))
                    ) : (
                        <div className='no_images'>
                            <p>No images uploaded</p>
                        </div>
                    )}
                </div>
            </div>
            <div className="news_container">
                <div className="news_heading">
                    <h1>Blog Section</h1>
                </div>
                <div className='news_section'>
                    <div className="news_upload">
                        <h2>Upload post</h2>
                        <form onSubmit={handlePostUpload}>
                            <label htmlFor="Title" className='news_label'>Title</label>
                            <input type="text" placeholder='Post Title' required className='news_input' value={postTitle} onChange={(e) => setPostTitle(e.target.value)} />

                            <label htmlFor="post image" className='news_label'>Post Image</label>
                            <input type="file" required className='news_input' onChange={(e) => setPostImage(e.target.files[0])} />

                            <label htmlFor="author" className='news_label'>Author</label>
                            <input type="text" placeholder='Author' required className='news_input' value={author} onChange={(e) => setAuthor(e.target.value)} />

                            <label htmlFor="message" className='news_label'>Message</label>
                            <textarea type="text" required className='news_textarea' value={message} onChange={(e) => setMessage(e.target.value)} />

                            <button className='news_btn' type="submit" disabled={isUploading}>Upload</button>
                            {isUploading && <p className='uploading_indicator'>Uploading...</p>}
                        </form>
                    </div>
                    <div className="news_uploaded">
                        <div className="uploaded_section">
                            <h1>Uploaded Post</h1>
                        </div>
                        <div className="uploaded_container">
                            {posts.length > 0 ? (
                                posts.map((post) => (
                                    <div className="uploaded_card" key={post.id}>
                                        <h1>{post.title}</h1>
                                        <img src={post.imageUrl} alt={post.title} />
                                        <h2>Author: {post.author}</h2>
                                        <p>{post.message}</p>
                                        <BiTrash className='news_icon' onClick={() => handleDeletePost(post.id)} />
                                    </div>
                                ))
                            ) : (
                                <div className='no_posts'>
                                    <p>No posts uploaded</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminGallery;
